'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetData = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWidgetDataFromState = (0, _get2.default)('widgetData');
var getRefreshedWidgetDataFromState = (0, _get2.default)('refreshedWidgetData');

var getWidgetData = exports.getWidgetData = (0, _reselect.createSelector)([getWidgetDataFromState, getRefreshedWidgetDataFromState], function (widgetData, refreshedWidgetDataRecords) {
  return refreshedWidgetDataRecords && refreshedWidgetDataRecords.size > 0 ? refreshedWidgetDataRecords.last() : widgetData;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getWidgetData.js
// module id = 23
// module chunks = 2 3